import request from '~/request/index.js'


/**
 * 查询面试候选人列表
  GET /api/v1/business/candidate/list
  接口ID：213235871
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-213235871 
 */
export const getCandidateListApi = (positionId, pageSize, pageNum, filter) => request.get(`/api/v1/business/candidate/list?isAsc=desc${filter?.orderByColumn ? `&orderByColumn=${filter?.orderByColumn}` : `&orderByColumn=updateTime`}${positionId ? `&positionId=${positionId}` : ``}&archived=1${pageSize ? `&pageSize=${pageSize}` : ``}${pageNum ? `&pageNum=${pageNum}` : ``}${filter?.name ? `&name=${filter.name}` : ``}${filter?.phone ? `&phoneNumber=${filter.phone}` : ``}${(filter?.interviewStatus !== null && filter?.interviewStatus !== undefined && filter?.interviewStatus !== 'undefined' && filter?.interviewStatus.length > 0) ? `&processStatusList=${filter?.interviewStatus.join(',')}` : ``}${(filter?.tags && filter?.tags.length > 0) ? `&tagIds=${filter?.tags.join(',')}` : ``}${((filter?.minNum * 1) >= 0 && (filter?.maxNum * 1) >= 0) ? `&scoreGe=${filter?.minNum}&scoreLe=${filter?.maxNum}` : ``}`)
/**
 * 获取人才库列表
 */
export const getTalentedListApi = ({
    pageSize,
    pageNum,
    isCollect = null,
    groupIds,
    filter = {}
}) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: filter.orderByColumn || 'updateTime',
        archived: 1,
        pageSize,
        pageNum,
        groupIds,
        name: filter.name,
        degree: filter.degree,
        createBy: filter.createBy,
        talentSource: filter.talentSource,
        tagIds: filter.tagIds,
        experienceLevel: filter.experienceLevel,
        hasResumeScore: filter.hasResumeScore,
        resumeText: filter.resumeText
    }
    if (filter?.createDate) {
        params.createDate = filter.createDate
    }
    if (filter?.createAfter) {
        params.createAfter = filter.createAfter
    }
    if (filter?.createBefore) {
        params.createBefore = filter.createBefore
    }
    if (filter?.processStatusList) {
        params.recruitmentStatusList = filter.processStatusList
    }
    if (filter?.profileId) {
        params.profileId = filter.profileId
    }
    if (filter?.notGroupIds) {
        params.notGroupIds = filter.notGroupIds
    }
    if (filter?.recruitmentStatus !== null && filter?.recruitmentStatus !== undefined && filter?.recruitmentStatus !== 'undefined') {
        params.recruitmentStatus = filter.recruitmentStatus
    }
    if (filter?.isCollect || filter?.isCollect === 0) {
        params.isCollect = filter.isCollect
    }
    if (filter?.hasGroup || filter?.hasGroup === 0) {
        params.hasGroup = filter.hasGroup
    }
    if (isCollect || isCollect === 0) {
        params.isCollect = isCollect
    }
    if (filter.positionId && filter.positionId !== null && filter.positionId !== 'undefined' && filter.positionId !== '' && filter.positionId !== 'null') {
        params.positionId = filter.positionId
    }
    if (filter.positionId === '') {
        params.positionIsNull = true
    }
    console.log(params)
    return request.get('/api/v1/business/candidate/list', { params })
}
/**
 * 删除面试候选人
  DELETE /api/v1/business/candidate/{ids}
  接口ID：210581265
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210581265
 */
export const delCandidateApi = (ids) => request.delete(`/api/v1/business/candidate/${ids}`)

/**
 * 修改面试候选人
  PUT /api/v1/business/candidate
  接口ID：210581264
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-210581264
 */
export const editCandidateApi = (data) => request.put(`/api/v1/business/candidate`, data)

/**
 * 新增候选人备注
 *   POST /api/v1/business/candidate-remark
 *   接口ID：242841586
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-242841586
 */
export const addCandidateRemarkApi = (data) => request.post(`/api/v1/business/candidate-remark`, data)
/**
 * 查询候选人备注列表
 *   GET /api/v1/business/candidate-remark/list
 *   接口ID：242824969
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-242824969
 */
export const getCandidateRemarkListApi = ({
    candidateId,
    pageSize,
    pageNum,

}) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: 'updateTime',
        archived: 1,
        pageSize,
        pageNum,
        candidateId,
    }
    return request.get('/api/v1/business/candidate-remark/list', { params })
}
/**
 * 修改候选人备注
 *   PATCH /api/v1/business/candidate-remark
 *   接口ID：243678530
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-243678530
 */
export const editCandidateRemarkApi = (data) => request.patch(`/api/v1/business/candidate-remark`, data)

/**
 * 删除候选人备注
 *   DELETE /api/v1/business/candidate-remark/{ids}
 *   接口ID：242840633
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-242840633
 */
export const delCandidateRemarkApi = (ids) => request.delete(`/api/v1/business/candidate-remark/${ids}`)


// /**
//  * 新增候选人关联人才标签
//  *   POST /api/v1/business/candidate-talent-tag
//  *   接口ID：243361573
//  *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-243361573
//  */
// export const addCandidateTalentTagApi=(data)=>request.post(`/api/v1/business/candidate-talent-tag`, data)

/**
 * 查询人才标签列表(底库)
 *   GET /api/v1/business/tag/list
 *   接口ID：243953604
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-243953604
 */
export const getTalentTagListApi = () => request.get(`/api/v1/business/tag/list`)

/**
 *    添加和删除删除也用这个接口
 *   PATCH /api/v1/business/candidate/tag
 *   接口ID：248505538
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-248505538
 */
export const editCandidateTagApi = (data) => request.patch(`/api/v1/business/candidate/tag`, data)

/**
 *  新增标签(地库)
 *   POST /api/v1/business/tag
 *   接口ID：218772116
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-218772116
 */
export const addTagApi = (data) => request.post(`/api/v1/business/tag`, data)
//
// /**
//  * 删除候选人关联人才标签
//  *   DELETE /api/v1/business/candidate-talent-tag/candidate/{candidateId}/talentTag/{talentTagId}
//  *   接口ID：243361982
//  *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-243361982
//  */
// export const deleteTalentTagApi =(candidateId,talentTagId)=>request.delete(`/api/v1/business/candidate-talent-tag/candidate/${candidateId}/talentTag/${talentTagId}`)

/**
 *   删除标签(底库)
 *   DELETE /api/v1/business/tag/{ids}
 *   接口ID：218772118
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-218772118
 */
export const deleteTagsApi = (ids) => request.delete(`/api/v1/business/tag/${ids}`)

/**
 *    修改标签(底库)
 *   PUT /api/v1/business/tag
 *   接口ID：218772117
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-218772117
 */
export const editTalentTagApi = (data) => request.put(`/api/v1/business/tag`, data)

/**
 * 查询指定候选人的面试方案
 *   GET /api/v1/business/process/candidate/{candidateId}/{isPast}
 *   接口ID：243941642
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-243941642
 */
export const getProcessByCandidateIdApi = (candidateId, isPast) => request.get(`/api/v1/business/process/candidate/${candidateId}/${isPast}`)

/**
 * 收藏面试候选人
 *   PATCH /api/v1/business/candidate/collect
 *   接口ID：245301442
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-245301442
 */
export const collectCandidateApi = (data) => request.patch(`/api/v1/business/candidate/collect`, data)
/**
 * 查询招聘流程列表
  GET /api/v1/process/recruitment-process/list
  接口ID：335727753
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727753
 */
export const getRecruitmentProcessListApi = (candidateId, status) => request.get(`/api/v1/process/recruitment-process/list?isAsc=desc&orderByColumn=updateTime&candidateId=${candidateId}${status ? `&recruitmentStatus=${status}` : ``}`)


/**
 * 查询人才分组列表
 *   GET /api/v1/business/talent-group/list
 *   接口ID：244774437
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-244774437
 */
export const getTalentGroupListApi = ({
    pageSize,
    pageNum,
    isCollect,
    type,

}) => {
    const params = {
        isAsc: 'desc',
        orderByColumn: 'updateTime',
        archived: 1,
        pageSize,
        pageNum,
        type,
    }
    return request.get(`/api/v1/business/talent-group/list`, { params })
}
/**
 * 新增人才分组
 *   POST /api/v1/business/talent-group
 *   接口ID：244783532
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-244783532
 */
export const addTalentGroupApi = (data) => request.post(`/api/v1/business/talent-group`, data)


/**
 * 修改人才分组
 *   PATCH /api/v1/business/talent-group
 *   接口ID：244793426
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-244793426
 */
export const editTalentGroupApi = (data) => request.patch(`/api/v1/business/talent-group`, data)

/**
 * 删除人才分组
 *   DELETE /api/v1/business/talent-group/{ids}
 *   接口ID：244795079
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-244795079
 */
export const deleteTalentGroupApi = (ids) => request.delete(`/api/v1/business/talent-group/${ids}`)

/**
 * 新增候选人关联分组
 *   post /api/v1/business/candidate-group
 *   接口ID：245247298
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-245247298
 */
export const addCandidateGroupApi = (data) => request.post(`/api/v1/business/candidate-group`, data)

/**
 * 删除候选人关联分组
 *   DELETE /api/v1/business/candidate-group/candidate/{candidateId}/group/{groupId}
 *   接口ID：245248836
 *   接口地址：https://app.apifox.com/link/project/5047271/apis/api-245248836
 */
export const deleteCandidateGroupApi = (candidateId, groupId) => request.delete(`/api/v1/business/candidate-group/candidate/${candidateId}/group/${groupId}`)

/**
 * 生成在线简历
  POST /api/v1/business/candidate/{candidateId}/online
  接口ID：252588921
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-252588921
 */
export const refreshCandidateApi = (candidateId) => request.post(`/api/v1/business/candidate/${candidateId}/online`)

/**
 * 提取简历内容
  POST /api/v2/business/candidate/{candidateId}/extract
  接口ID：267632362
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-267632362
 */
export const extractCandidateApi = (candidateId) => request.post(`/api/v2/business/candidate/${candidateId}/extract`)


/**
 * 分析简历内容
  POST /api/v2/business/candidate/{candidateId}/analysis
  接口ID：267632744
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-267632744
 */
export const analysisCandidateApi = (candidateId) => request.post(`/api/v2/business/candidate/${candidateId}/analysis`)

/**
 * 获取企业微信授权配置
 * GET /wecom-auth/config
 */
export const getWecomAuthApi = () => request.get('/wecom-auth/config')

/**
 * 获取企业微信授权签名
 * GET /wecom-auth/config-signature
 */
export const getWecomConfigSignatureApi = (url) => request.get(`/wecom-auth/config-signature?url=${url}`)

/**
 * 获取应用授权签名
 * GET /wecom-auth/agent-config-signature
 */
export const getWecomAgentConfigSignatureApi = (url) => request.get(`/wecom-auth/agent-config-signature?url=${url}`)

/**
 * 新增候选人得分
  POST /api/v1/business/candidate-score
  接口ID：276499984
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-276499984
 */
export const postCandidateScoreApi = (data) => request.post(`/api/v1/business/candidate-score`, data)

/**
 * 获取候选人得分
  GET /api/v1/business/candidate-score/candidate/{candidateId}
  接口ID：276500000
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-276500000
 */
export const getCandidateScoreApi = (candidateId) => request.get(`/api/v1/business/candidate-score/candidate/${candidateId}`)

/**
 * 通过候选人ID和需求ID查询候选人分析
  GET /api/v1/process/candidate-analysis/query
  接口ID：401700009
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-401700009
 */
export const getCandidateAnalysisApi = (candidateId, recruitmentId) => request.get(`/api/v1/process/candidate-analysis/query?candidateId=${candidateId}&recruitmentId=${recruitmentId}`)
/**
 * 通过候选人ID和需求ID查询或生成候选人分析
  POST /api/v1/process/candidate-analysis/generate
  接口ID：401846771
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-401846771
 */
export const postCandidateAnalysisApi = (data) => request.post(`/api/v1/process/candidate-analysis/generate`, data)


/**
 * 查询评分列表
  GET /api/v1/business/candidate-score/list
  接口ID：284535239
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-284535239
 */
export const getCandidateScoreListApi = (profileId, orderByColumn) => request.get(`/api/v1/business/candidate-score/list?profileId=${profileId}${orderByColumn ? `&orderByColumn=${orderByColumn}` : ``}`)



/**批量修改分组
  PUT /api/v1/business/candidate-group/batch
  接口ID：295491414
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-295491414
 */
export const putCandidateGroupBatchApi = (data) => request.put(`/api/v1/business/candidate-group/batch`, data)


/**批量添加候选人到分组
  POST /api/v1/business/candidate-group/add-batch
  接口ID：298242385
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-298242385
 */
export const postCandidateGroupAddBatchApi = (data) => request.post(`/api/v1/business/candidate-group/add-batch`, data)

/**
 * 获取岗位下候选人洞察建议
  GET /api/v1/business/candidate/position/suggestion
  接口ID：304168337
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-304168337{params}?suggestionType=${suggestionType}
 */
export const getCandidatePositionSuggestionApi = ({ suggestionType, date }) => {

    const params = {
        suggestionType,
        date
    };

    return request.get(`/api/v1/business/candidate/position/suggestion`, { params })
}

/**
 * 获取岗位下候选人技能、学历、工作年限分布
  GET /api/v1/business/candidate/position/distribution
  接口ID：305966143
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-305966143
 */
export const getCandidatePositionDistributionApi = (createAfter) => {
    let params = {};
    if (createAfter) {
        params.createAfter = createAfter
    }
    return request.get(`/api/v1/business/candidate/position/distribution`, { params })
}
/**
 * 获取搜索任务列表
  GET /api/v1/business/search-task/list
  接口ID：307304892
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-307304892
 */
export const getSearchTaskListApi = () => {
    return request.get(`/api/v1/business/search-task/list`)
}
/**
 * 创建搜索任务
  POST /api/v1/business/search-task
  接口ID：307559806
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-307559806
 */

export const postSearchTaskApi = (params) => {
    return request.post(`/api/v1/business/search-task`, params)
}

/**
 * 修改搜索任务
  PUT /api/v1/business/search-task
  接口ID：307560050
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-307560050
 */
export const putSearchTaskApi = (params) => {
    return request.put(`/api/v1/business/search-task`, params)
}
/**
 * 删除搜素任务（人才雷达）
  DELETE /api/v1/business/search-task/{ids}
  接口ID：308844563
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-308844563
 * @param {*} params 
 * @returns 
 */
export const delSearchTaskApi = (ids) => {
    return request.delete(`/api/v1/business/search-task/${ids}`)
}

/**
 * 查询标准公司列表
  GET /api/v1/business/std-company/list
  接口ID：307449271
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-307449271
 */
export const getStdCoompanyListApi = (params) => {
    return request.get(`/api/v1/business/std-company/list`, { params })
}
/**
 * 新增标准公司
  POST /api/v1/business/std-company
  接口ID：308148237
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-308148237
 */
export const postStdCoompanyApi = (params) => {
    return request.post(`/api/v1/business/std-company`, params)
}
/**
 * 修改标准公司
  PUT /api/v1/business/std-company
  接口ID：313250046
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-313250046
 */
export const putStdCoompanyApi = (params) => {
    return request.put(`/api/v1/business/std-company`, params)
}
/**
 * 删除标准公司
  DELETE /api/v1/business/std-company/{ids}
  接口ID：313250047
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-313250047
 */
export const delStdCoompanyApi = (ids) => {
    return request.delete(`/api/v1/business/std-company/${ids}`)
}

/**
 * 新增候选人初筛
  POST /api/v1/process/candidate-screening
  接口ID：335727217
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727217
 */
export const postCandidateScreenApi = (data) => {
    return request.post(`/api/v1/process/candidate-screening`, data)
}
/**
 * 获取候选人初筛详细信息
  GET /api/v1/process/candidate-screening/{id}
  接口ID：335727216
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727216
 */
export const getCandidateScreenApi = (id) => {
    return request.get(`/api/v1/process/candidate-screening/${id}`)
}
/**
 * 提交初筛
  PUT /api/v1/process/candidate-screening/submit
  接口ID：335727218
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727218
 */
export const submitCandidateScreenApi = (data) => {
    return request.put(`/api/v1/process/candidate-screening/submit`, data)
}

/**
 * 修改候选人初筛
  PUT /api/v1/process/candidate-screening
  接口ID：335727219
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727219
 */
export const putCandidateScreenApi = (data) => {
    return request.put(`/api/v1/process/candidate-screening`, data)
}
/**
 * 取消候选人初筛
  PUT /api/v1/process/candidate-screening/cancel/{id}
  接口ID：335727220
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-335727220
 */
export const putCandidateScreenCancelApi = (id) => {
    return request.put(`/api/v1/process/candidate-screening/cancel/${id}`)
}
/**
 * 查询候选人通过候选人状态和候选人查询候选人初筛
 */
export const getCandidateScreenCancelApi = (candidateId, status) => {
    return request.get(`/api/v1/process/candidate-screening/list?candidateId=${candidateId}${status ? `&screeningStatus=${status}` : ``}`)
}

/**
 * 查询候选人最新的初筛记录
  GET /api/v1/process/candidate-screening/latest/{candidateId}
  接口ID：340678053
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-340678053
 */
export const getCandidateScreenLatestApi = (candidateId) => {
    return request.get(`/api/v1/process/candidate-screening/latest/${candidateId}`)
}

/**
 * 查询候选人分析状态
  GET /api/v2/business/candidate/{candidateId}/analysis-status
  接口ID：381729163
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-381729163
 */
export const getCandidateAnalysisStatusApi = (candidateId) => {
    return request.get(`/api/v2/business/candidate/${candidateId}/analysis-status`)
}

/**
 * 查询求职者信息列表
  GET /api/v1/business/applicant/list
  接口ID：308148195
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-308148195
 */

export const getApplicantListApi = ({ searchPositionId, pageSize, pageNum, filter = {} }) => {

    const params = {
        searchPositionId,
        isAsc: 'desc',
        orderByColumn: filter.orderByColumn || 'createTime',
        pageSize,
        pageNum,

    }
    return request.get(`/api/v1/business/applicant/list`, { params })
}

/**
 * 批量变更岗位
  PATCH /position/batch
  接口ID：396096830
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-396096830
 */
export const patchPositionBatchApi = (data) => {
    return request.patch(`/api/v1/business/candidate/position/batch`, data)
}
/**
 * 批量取消候选人推荐
  POST /api/v1/process/candidate-screening/batch-cancel
  接口ID：398383381
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-398383381
 */
export const batchCancelTalentsRecommendApi = (data) => {
    return request.post(`/api/v1/process/candidate-screening/batch-cancel`, data)
}
/**
 * 批量催办候选人初筛
  POST /api/v1/process/candidate-screening/batch-remind
  接口ID：398041645
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-398041645
 */
export const batchRemindTalentsRecommendApi = (data) => {
    return request.post(`/api/v1/process/candidate-screening/batch-remind`, data)
}

/**
 * 获取未审核的推荐候选人列表
  GET /api/v1/process/candidate-screening/pending-review
  接口ID：398354965
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-398354965 
 */
export const getPendingReviewListApi = (data) => {

    let params = {
        isAsc: 'desc',
        orderByColumn: 'createTime',
    }
    if (data?.pageSize) {
        params.pageSize = data.pageSize
    }
    if (data?.pageNum) {
        params.pageNum = data.pageNum
    }
    return request.get(`/api/v1/process/candidate-screening/pending-review`, { params })
}

/**
 * 分页查询
 * @param {Object} data - 查询参数对象
 * @param {string|number} [data.candidateId] - 候选人ID
 * @param {string|number} [data.recruitmentId] - 需求ID
 * @param {boolean} [data.allRecruitments] - 是否查询全部需求 (用于初筛列表查询)
 * @param {Array} [data.screeningStatusList] - 初筛状态列表 (多个)
 * @param {string} [data.startTime] - 查询开始时间
 * @param {string} [data.endTime] - 查询结束时间
 * @param {number} [data.pageSize] - 分页大小
 * @param {number} [data.pageNum] - 当前页数
 * @param {string} [data.orderByColumn='createTime'] - 排序列 (默认: createTime)
 * @param {string} [data.isAsc='desc'] - 排序的方向desc或者asc (默认: desc)
 * @param {string|number} [data.status] - 初筛状态（兼容旧版本）
 * @param {string|number} [data.screeningStatus] - 初筛状态
 * @param {string|number} [data.screenedBy] - 筛选人ID（我评估的简历）
 * @returns {Promise<Object>} - 查询结果
 */
export const getCandidateScreenListApi = (data = {}) => {
    // 兼容旧版本：如果第一个参数是字符串或数字，认为是 candidateId
    if (typeof data === 'string' || typeof data === 'number') {
        const candidateId = data;
        const status = arguments[1];
        return request.get(`/api/v1/process/candidate-screening/list?candidateId=${candidateId}${status ? `&screeningStatus=${status}` : ``}`)
    }

    // 新版本：使用对象参数
    const params = {
        orderByColumn: data.orderByColumn || 'createTime',
        isAsc: data.isAsc || 'desc'
    };

    if (data.candidateId !== undefined && data.candidateId !== null && data.candidateId !== '') {
        params.candidateId = data.candidateId;
    }
    if (data.recruitmentId !== undefined && data.recruitmentId !== null && data.recruitmentId !== '') {
        params.recruitmentId = data.recruitmentId;
    }
    if (data.allRecruitments !== undefined && data.allRecruitments !== null) {
        params.allRecruitments = data.allRecruitments;
    }
    if (data.screeningStatusList && Array.isArray(data.screeningStatusList) && data.screeningStatusList.length > 0) {
        params.screeningStatusList = data.screeningStatusList.join(',');
    }
    if (data.startTime) {
        params.startTime = data.startTime;
    }
    if (data.endTime) {
        params.endTime = data.endTime;
    }
    if (data.pageSize !== undefined && data.pageSize !== null) {
        params.pageSize = data.pageSize;
    }
    if (data.pageNum !== undefined && data.pageNum !== null) {
        params.pageNum = data.pageNum;
    }
    // 兼容旧版本的 status 参数
    if (data.status !== undefined && data.status !== null && data.status !== '') {
        params.screeningStatus = data.status;
    }
    // screeningStatus 参数（优先于 status）
    if (data.screeningStatus !== undefined && data.screeningStatus !== null && data.screeningStatus !== '') {
        params.screeningStatus = data.screeningStatus;
    }
    if (data.screenedBy !== undefined && data.screenedBy !== null && data.screenedBy !== '') {
        params.screenedBy = data.screenedBy;
    }

    return request.get('/api/v1/process/candidate-screening/list', { params });
}

/**
 * 查询当前用户所关联的招聘需求，根据候选人id和候选人关联的招聘需求id列表。返回最新的一条记录。如果没有就返回null，。如果有就是返回最新的一条记录
  GET /api/v1/process/candidate-analysis/latest-by-user-recruitments
  接口ID：407110564
  接口地址：https://app.apifox.com/link/project/5047271/apis/api-407110564
 */
export const getLatestCandidateAnalysisByUserRecruitmentsApi = (candidateId) => {
    return request.get(`/api/v1/process/candidate-analysis/latest-by-user-recruitments?candidateId=${candidateId}`)
}